import { render, staticRenderFns } from "./StudentSpeakingSubmission.vue?vue&type=template&id=d0d1ddfa&scoped=true"
import script from "./StudentSpeakingSubmission.vue?vue&type=script&lang=js"
export * from "./StudentSpeakingSubmission.vue?vue&type=script&lang=js"
import style0 from "./StudentSpeakingSubmission.vue?vue&type=style&index=0&id=d0d1ddfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0d1ddfa",
  null
  
)

export default component.exports